<template>
    <span :class="{'transparent': value <= 0, 'is-size-6': !total}">
      <span v-if="euro">{{displayValue | round(0) | prettyPrice}} {{$currency}}</span>
      <span v-else-if="percentage">{{displayValue | round(2) }} %</span>
      <span v-else>
        {{displayValue}}
      </span>
    </span>
</template>

<script>
  export default {
    name: 'StatValue',
    props: {
      value: {
        type: [Number, String],
        required: true
      },
      euro: {
        type: Boolean,
        default: false
      },
      percentage: {
        type: Boolean,
        default: false
      },
      total: {
        type: Boolean,
        default: false
      }
    },
    components: {},
    data () {
      return {}
    },
    computed: {
      displayValue () {
        return Number(this.value)
      }
    },
    methods: {}
  }
</script>

<style>
  .transparent {
    opacity: 0.25;
  }

</style>



// WEBPACK FOOTER //
// src/components/utils/StatValue.vue